module.exports = __webpack_public_path__ + "static/ch-icon-fec02ff84ff2f7cac755fd26daca2b5e.png";